import { Link } from 'react-router-dom';
import { Card } from '@/components/common/Card';
import { ROUTES } from '@/app/router/routes';

function ErrorPanel({ code, title, message }: { code: string; title: string; message: string }) {
  return (
    <Card className="mx-auto max-w-md px-6 py-12 text-center">
      <p className="text-3xl font-semibold text-subtle">{code}</p>
      <h1 className="mt-2 text-lg font-semibold text-ink">{title}</h1>
      <p className="mt-1 text-sm text-muted">{message}</p>
      <Link
        to={ROUTES.dashboard}
        className="mt-5 inline-block bg-accent px-3.5 py-2 text-sm font-semibold text-accent-fg hover:bg-accent-hover"
      >
        Back to dashboard
      </Link>
    </Card>
  );
}

export function ForbiddenPage() {
  return (
    <ErrorPanel
      code="403"
      title="You do not have access to this page"
      message="Your account does not hold the permission this page requires. Ask an administrator if you need it."
    />
  );
}

export function NotFoundPage() {
  return (
    <ErrorPanel code="404" title="Page not found" message="This page does not exist, or it has moved." />
  );
}
